import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CHART_PALETTE } from '../../../theme/chartColors';

const PieDonutRenderer = ({ data, config, compact, donut = false }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div className="dc-no-data">No pie data available</div>;
  }

  const { xKey, yKeys = [], nameKey: cfgNameKey, valueKey: cfgValueKey, colors = CHART_PALETTE, showLegend = true } = config || {};
  
  // Robust data key detection
  const dataKey = cfgValueKey || yKeys[0] || 'value';
  const nameKey = cfgNameKey || xKey || 'name';

  // Final fallback: if keys don't exist in data, find them
  const actualDataKey = data[0][dataKey] !== undefined ? dataKey : Object.keys(data[0]).find(k => typeof data[0][k] === 'number') || 'value';
  const actualNameKey = data[0][nameKey] !== undefined ? nameKey : Object.keys(data[0]).find(k => typeof data[0][k] === 'string') || 'name';

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart margin={compact ? { top: 0, right: 0, left: 0, bottom: 0 } : { top: 20, right: 20, left: 20, bottom: 20 }}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={donut ? (compact ? 40 : 60) : 0}
          outerRadius={compact ? 60 : 100}
          paddingAngle={donut ? 5 : 0}
          dataKey={actualDataKey}
          nameKey={actualNameKey}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} stroke="var(--bg-card)" strokeWidth={2} />
          ))}
        </Pie>
        <Tooltip contentStyle={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-primary)', borderRadius: '8px' }} />
        {!compact && showLegend && <Legend wrapperStyle={{ fontSize: '12px' }} />}
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieDonutRenderer;
